import React from "react";
import { Layout } from "antd";

const { Header, Footer, Sider, Content } = Layout;

export default function footer() {
  const year = new Date().getFullYear();
  return (
    <Footer
      style={{
        textAlign: "center",
        bottom: "5px",
        // position: "absolute",
        width: "100%",
      }}
    >
      ©{year} Hotel Association of New York City
    </Footer>
  );
}
